/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import SelectionBoxRender from './AGGridCustomComponent/selectionBoxRender';
import PlanNameCustomComponent from './AGGridCustomComponent/planNameCustomComponent';
import CommentsAndCorrespondence from './AGGridCustomComponent/CommentsAndCorrespondence';
import DeleteBoxRender from './AGGridCustomComponent/deleteBoxRender';
import {
  addNewDateToStore,
  updateDatesRows,
  updatePlanWhenUserUpdateFromCustomComponent,
} from '../store/actions';
import { tableHead } from './tableHead';
import StartEndDateComp from './AGGridCustomComponent/StartEndDateComp';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export default function DatesGrid(props) {
  const {
    gridHeight,
    setDisabledSaveCancelBtn,
    disabledSaveCancelBtn,
    fullScreenView,
    setFullScreenView,
    goToClient,
    goToGroup,
    goToRebateManage,
    handleClickOpenDelete,
    cgpValues,
    planByCGP,
    kcRoles,
    validateRequest,
    isReadOnly,
    isEnablebyRole,
    checkActionAccessByRole,
    setErrorMessages,
    datesGridApiRef
  } = props;
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [showComments, setShowComments] = useState(false);
  const [rowGridPrimaryKey, setRowGridPrimaryKey] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const frameworkComponents = {
    SelectionBoxRender: (props) => (
      <SelectionBoxRender {...props} isEnablebyRole={isEnablebyRole} />
    ),
    CommentsAndCorrespondence: CommentsAndCorrespondence,
    DeleteBoxRender: (cellInfo) => (
      <DeleteBoxRender
        cellInfo={cellInfo}
        setCorrLinkId={setCorrLinkId}
        setRowGridPrimaryKey={setRowGridPrimaryKey}
        setShowComments={setShowComments}
        handleClickOpenDelete={handleClickOpenDelete}
        setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
        isEnablebyRole={isEnablebyRole}
      />
    ),
    StartDate: (props) => (
      <StartEndDateComp {...props} isEnablebyRole={isEnablebyRole} />
    ),
    EndDate: (props) => (
      <StartEndDateComp {...props} isEnablebyRole={isEnablebyRole} />
    ),
    PlanNameCustomComponent: (props) => (
      <PlanNameCustomComponent {...props} isEnablebyRole={isEnablebyRole} />
    ),
    CheckBox: ({ column, node, value, data }) => {
      const datesRows = useSelector((state) => {
        return (
          state.sharedState.PlanReducer.datesRows?.filter(
            (item) => !item.deleteRecord
          ) ?? []
        );
      });

      return (
        <>
          <div className="tbl-checkbox">
            <FormControlLabel
              data-testid="checkBox"
              control={<Checkbox color="primary" />}
              onClick={(e) => {
                const checkedVal = e.target.checked ? 1 : 0;
                node.setDataValue(column.colId, checkedVal);
                dispatch(
                  updatePlanWhenUserUpdateFromCustomComponent({
                    ...data,
                    updateRecord: true,
                  })
                );
              }}
              onKeyDown={(e) => {
                // if (
                //   ((e.key === 'Tab' && !e.shiftKey) ||
                //     e.key === 'ArrowRight') &&
                //   column.colId === 'excludeSuppInd'
                // ) {
                //   addNewDate(e, datesRows);
                // }
              }}
              checked={value}
              value={value}
              aria-label="checkBox"
              disabled={!isEnablebyRole}
            />
          </div>
        </>
      );
    },
  };
  const dispatch = useDispatch();
  const datesRows = useSelector((state) => {
    return (
      state.sharedState.PlanReducer.datesRows?.filter(
        (item) => !item.deleteRecord
      ) ?? []
    );
  });

  const onEditingStopped = (params) => {
    if (params && params.value === params.oldValue && disabledSaveCancelBtn) {
      setDisabledSaveCancelBtn(true);
    } else {
      setDisabledSaveCancelBtn(false);
    }
  };

  const getExistingCommentLinkIds = async (idList) => {
    try {
      const response = await axios.post(
        serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS,
        {
          corrLinkId: idList,
        }
      );
      return response.data?.data ?? [];
    } catch (e) {
      return [];
    }
  };

  const checkCommentsExist = async () => {
    const res = await getExistingCommentLinkIds([corrLinkId]);
    const ccCommentsExist = res?.includes(corrLinkId) ? 1 : 0;
    const updatedDateList = datesRows.map((item) => {
      if (item.corrLinkId === corrLinkId) {
        return {
          ...item,
          ccCommentsExist,
        };
      } else return item;
    });
    dispatch(updateDatesRows([...updatedDateList]));
  };

  useEffect(() => {
    if (!showComments && corrLinkId) checkCommentsExist();
  }, [showComments]);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const addNewDate = (e, data) => {
    if (validateRequest(data, false)) {
      setErrorMessages([]);
      const updatedPlanList = data
        ? data.filter((item) => item.index !== undefined)
        : datesRows && datesRows.filter((item) => item.index !== undefined);
      const index = updatedPlanList.length === 0 ? 0 : updatedPlanList.length;
      let planName = '';
      let clientName = updatedPlanList ? updatedPlanList[0].clientName : '';
      let groupName = updatedPlanList ? updatedPlanList[0].groupName : '';
      let rebateProgramCd = '';
      let endDateHigh = updatedPlanList ? updatedPlanList[0].endDt : '';
      updatedPlanList.forEach((element) => {
        if (!element?.endDt) {
          planName = element.planName;
          rebateProgramCd = element.rebateProgramCd;
          clientName = element.clientName;
          groupName = element.groupName;
          return;
        }
        if (endDateHigh && element.endDt > endDateHigh) {
          endDateHigh = element.endDt;
          planName = element.planName;
          clientName = element.clientName;
          groupName = element.groupName;
        }
      });

      const newDate = [
        {
          cg_id: null,
          cgpId: {
            clientId: '',
            groupId: '',
            planId: '',
            startDt: null,
          },
          index: index,
          endDt: null,
          planName: planName || updatedPlanList[0]?.planName,
          rebateProgramCd:
            rebateProgramCd || updatedPlanList[0]?.rebateProgramCd,
          ltcPlanInd: 0,
          excludeSuppInd: 0,
          lastUpdateDt: '',
          lastUpdateUserId: '',
          corrLinkId: null,
          clientName: clientName,
          groupName: groupName,
          newRecord: true,
          startDt: null,
        },
      ];
      setDisabledSaveCancelBtn(false);
      updatedPlanList.unshift(newDate[0]);
      dispatch(updateDatesRows(updatedPlanList));
      dispatch(addNewDateToStore(updatedPlanList));
    }
  };
  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.cgpId;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        CLIENT_ID: `${selectedRow?.clientId}`,
        GROUP_ID: `${selectedRow?.groupId}`,
        PLAN_ID: `${selectedRow?.planId}`,
        START_DT: `${selectedRow?.startDt} 00:00`,
      });
    }
  };

  return (
    <>
      <div className="panel tBillPanel-space pb-0">
        <div className="clearfix" />
        <Grid
          gridHeight={gridHeight}
          goToClient={goToClient}
          goToGroup={goToGroup}
          goToRebateManage={goToRebateManage}
          planByCGP={planByCGP}
          isPlanScreen
          rowData={datesRows}
          columnDefs={tableHead}
          frameworkComponents={frameworkComponents}
          data-testid="onEditingStopped"
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          singleClickEdit={false}
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          onCellValueChanged={onEditingStopped}
          onGridReady={(params) => (datesGridApiRef.current = params.api)}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenViewClick}
          exportFile
          fileName="Plan Details"
          handleClickOpenDelete={handleClickOpenDelete}
          handleViewHistory={handleViewHistory}
          addAction={addNewDate}
          addTxt={
            checkActionAccessByRole(
              process.env.REACT_APP_HIDE_ACCESS_ROLES,
              kcRoles
            ) && 'Add New Date'
          }
          disableAddAction={
            isReadOnly ||
            !checkActionAccessByRole(
              process.env.REACT_APP_STATE_ONLY_ROLE,
              kcRoles
            )
          }
        />
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="CGP"
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={`${rowGridPrimaryKey?.cgpId?.clientId}${rowGridPrimaryKey?.cgpId?.groupId}${rowGridPrimaryKey?.cgpId?.planId}${rowGridPrimaryKey?.cgpId?.startDt}`}
        />
      ) : null}
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="CGP"
          keyValue={keyValue}
        />
      )}
    </>
  );
}
